<template>
	<div id="register">
		<toptitle :title="title" :isShowBack="isShowBack"></toptitle>
		<div class="reg_title">挂号信息</div>
		<div class="reg_info">
			<div class="list_item">
				<img src="../../assets/doc.png" />
				<span>{{docinfo.name}}：</span>
				<span>{{docinfo.keshi}}</span>
			</div>
			<div class="list_item">
				<img src="../../assets/date.png" />
				<span>日期：</span>
				<span>{{time}}</span>
			</div>
			<div class="list_item">
				<img src="../../assets/hosp.png" />
				<span>医院：</span>
				<span>成都西部甲状腺医院</span>
			</div>
			<div class="list_item">
				<img src="../../assets/addr.png" />
				<span>地址：</span>
				<span>成都市金牛区一环路北二段一号</span>
			</div>
		</div>
		<div class="from">
			<div class="form-item">
				<label for="namebr">姓名：</label>
				<input type="text" name="namebr" id="namebr" placeholder="请输入你的姓名" v-model="namebr"/>
			</div>
			<div class="form-item">
				<label for="tel">电话：</label>
				<input type="text" name="tel" id="tel" placeholder="请输入你的电话" v-model="tel"/>
			</div>
			<div class="form-item">
				<label for="age">年龄：</label>
				<input type="text" name="age" id="age" placeholder="请输入你的年龄" v-model="age"/>
			</div>
			<p class="tishi"><span>*</span>为保证顺利就诊，姓名，电话，年龄等务必真实有效。个人信息仅供您就诊使用，请您放心填写。</p>
			
			<div class="form-item">
				<textarea placeholder="请简述你的病情......" v-model="bingqing"></textarea>
			</div>
			<div class="guize">
				<h2>预约规则</h2>
				<p><span>*</span>网上挂号实行实名制预约，您必须填写就诊患者的真实信息，并在挂号时出示身份证，因患者信息真实性问题导致的就诊失败由患者自己负责。</p>
			</div>
			<div class="button"><button @click="tijiao" :disabled="isdisabled">提交预约</button></div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	#register {
		padding-top: 100px;
		// padding-bottom: 110px;
		background: #F1F1F1;

		.top_title {
			width: 100%;
			height: 100px;
			line-height: 100px;
			background: #109FC7;
			text-align: center;
			color: #fff;
			font-size: 32px;
			font-weight: bold;
			letter-spacing: 4px;
		}

		.reg_title {
			text-align: center;
			padding: 3% 0;
			font-size: 28px;
			background: #fff;
		}

		.reg_info {
			background: #fff;
			margin-top: 20px;
			padding: 20px 40px;

			.list_item {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				padding: 10px 0;

				img {
					width: 36px;
					height: 36px;
				}

				span {
					font-size: 28px;
					margin-left: 20px;
				}
			}
		}

		.from {
		
			display: block;
			margin-top: 20px;
			
			.form-item{
				width: 100%;
				padding: 20px 0;
				border-bottom: 1px solid #EEEEEE;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				padding: 20px 40px;
				background: #fff;
				label{
					font-size: 28px;
					color: red;
					// margin-right: 10px;
					width: 20%;
					text-align: center;
				}
				input{
					display: block;
					width: 80%;
					text-overflow: clip;
					overflow: hidden;
					white-space: nowrap;
					border: none;
				}
			}
			p.tishi{
				font-size: 24px;
				line-height: 40px;
				padding: 20px 40px;
				background: #fff;
				color: #979797;
				margin-bottom: 20px;
				span{color: red;line-height: 40px;margin-right: 10px;}
			}
			textarea{width: 100%;height: 200px;box-sizing: border-box;resize: none;
				background: #fff;
				font-size: 28px;
				border: none;}
			.guize{
				padding: 20px 40px;
				background: #fff;
				font-size: 28px;
				line-height: 40px;
				color: #979797;
				margin-top: 20px;
				margin-bottom: 100px;
				h2{font-size: 30px;color: #000;}
				p{
				font-size: 24px;
				line-height: 46px;
				padding: 20px 40px 0;
				background: #fff;
				color: #979797;	
				}
				span{color: red;margin-right: 10px;}
				
			}
			.button{
				margin-top: 20px;
				width: 100%;height: 80px;
				text-align: center;
				background: #fff;
				position: fixed;
				bottom: 0;
				left: 0;
				button{
					background-color: #109FC7;
					color: #fff;
					font-size: 32px;
					width: 250px;
					height: 70px;
					letter-spacing: 4px;
					border-radius: 10px;
				}
			
			}
		}
	}
</style>

<script>
	import {
		Toast
	} from "mint-ui";
	import toptitle from '@/components/Toptitle';
	export default {
		name: "Register",
		data() {
			return {
				time:[],
				docinfo:{
					name:'1',
					keshi:'2'
				},
				tit:null,
				information:null,
				namebr:null,
				tel:null,
				age:null,
				bingqing:null,
				isShowBack:true,
				title:'成都西部甲状腺医院挂号平台',
				isdisabled:false
			};
		},
		created() {
			console.log(this.$route.params.time);
			// 获取跳转带的医生id参数
			if(this.$route.params.time==undefined||this.$route.params.docinfo==undefined){
				// 带的数据不存在跳到首页
				this.$router.push({
					name: 'Index',
				})
			}else{
				this.time=this.$route.params.time;
				this.docinfo=this.$route.params.docinfo;
				// console.log(this.time);
				// console.log(this.docinfo);
				// console.log(this.$route.params);
			}
		},
		methods: {
			tijiao(){
				if(this.namebr==null||this.tel==null||this.age==null||this.bingqing==null){
					Toast({
						message: "请正确填写你的信息",
						position: 'center',
						duration: 2000
					});
					return;
				}
				var url = window.location.href;
				this.information=`
					</br>
					患者姓名：${this.namebr};</br>
					电话：${this.tel};</br>
					年龄：${this.age};</br>
					病情：${this.bingqing};</br>
					预约时间：${this.time};</br>
					预约医生：${this.docinfo.name};</br>
					来源：${url};</br>
				`;
				this.tit=`在线自助挂号：患者姓名【${this.namebr}】 手机【${this.tel}】申请信息，请相关负责人查收后及时跟进,谢谢！`;
				// 请求发送邮件接口
				let params = {
						title: this.tit,
						information: this.information
					
				};
				this.isdisabled=true;
				// console.log(params);
				this.$http.post(this.$api.GHemail, params).then(res => {
					console.log('发送成功');
					console.log(res);
					if (res.data.code == 1) {
						Toast({
							message:"预约成功",
							position: 'center',
							duration: 2000
						});
						this.$router.push({
							name: 'Index',
						})
					} else {
						Toast({
							message: "预约失败，请稍后重试",
							position: 'center',
							duration: 2000
						});
					}
				}).catch(error => {
					console.log('发送失败');
					console.log(error);
					this.isdisabled=false;
					Toast({
						message: error.data.msg,
						position: 'center',
					});
				});
			}
		},
		components: {
			toptitle
		}
	};
</script>
